import { render } from "./SectionHeading.vue?vue&type=template&id=69b3f210&scoped=true&ts=true"
import script from "./SectionHeading.vue?vue&type=script&lang=ts"
export * from "./SectionHeading.vue?vue&type=script&lang=ts"

import "./SectionHeading.vue?vue&type=style&index=0&id=69b3f210&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b3f210"]])

export default __exports__